export enum DashboardOrderBy {
    ProjectNameAsc = 'projectNameAsc',
    ProjectNameDesc = 'projectNameDesc',
    TimeProgressAsc = 'timeProgressAsc',
    TimeProgressDesc = 'timeProgressDesc',
    ProjectProgressAsc = 'projectProgressAsc',
    ProjectProgressDesc = 'projectProgressDesc',
}
